export default __webpack_public_path__ + "static/media/avatarB7.4b5b21ba.png";